export default __webpack_public_path__ + "static/media/backgroundTable.3f42347a.png";